import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useProjectMentorGuide } = getCRUDHooks({
  entityName: 'projectMentorGuide',
  get: ({ projectId }) =>
    clientApi.getOCClient().helpers.learningContent.projects.getMentorGuide(projectId),
});

// eslint-disable-next-line import/prefer-default-export
export { useProjectMentorGuide };
